import { LabelValueOptionModel } from '@/domain/models/onboarding/label-value-option-model'
import { SkillModel } from '@/domain/models/onboarding/user-onboarding-model'
import { OnboardingOptions } from '@/domain/usecases/onboarding/onboarding-options'
import { UserOnboarding } from '@/domain/usecases/onboarding/user-onboarding'
import { queryClient } from '@/infra/http'
import { importRemote } from '@/main/routes/helpers/loaders'

export type UserInterestAreasSkillsLoaderType = {
  interestAreas: {
    selected: number[]
    options: LabelValueOptionModel<number>[]
  }
  skills: {
    selected: SkillModel[]
    options: LabelValueOptionModel<number>[]
  }
}

/**
 * Loads user interest areas and skills data with available options
 * Used for managing user's interest areas and skills preferences
 */
export async function loadUserInterestAreasSkills(): Promise<UserInterestAreasSkillsLoaderType> {
  // Get both remote services in parallel
  const [remoteUserOnboarding, remoteOnboardingOptions] = await Promise.all([
    importRemote<UserOnboarding>('makeRemoteUserOnboarding', queryClient),
    importRemote<OnboardingOptions>('makeRemoteOnboardingOptions', queryClient)
  ])

  // Fetch user data and options in parallel
  const [userData, optionsStep3, optionsStep4] = await Promise.all([
    remoteUserOnboarding.get(),
    remoteOnboardingOptions.getStep3(),
    remoteOnboardingOptions.getStep4()
  ])

  return {
    interestAreas: {
      selected: userData.interest.areasId,
      options: optionsStep3.interestAreas
    },
    skills: {
      selected: userData.interest.skills,
      options: optionsStep4.skillOptions
    }
  }
}
